import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import Stack from 'react-bootstrap/Stack';

export const Schema = Yup.object().shape({
    terms: Yup.bool().required().oneOf([true], 'Die Datenschutzbestimmungen müssen akzeptiert werden'),
});

export const PrivacyConsentSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { dataSecurityUrl } = props;
    return (
        <>
            <Form.Group className="mb-2">
                Datenschutzerklärung
            </Form.Group>
            <Stack gap={2}>
                <Form.Group controlId="privacyConsent">
                    <Form.Check
                        required
                        name="terms"
                        type="checkbox"
                        onChange={handleChange}
                        isInvalid={touched.terms && !!errors.terms}
                        feedback={errors.terms}
                        feedbackType="invalid"
                        label={<span>* Ich bin mit der <a href={dataSecurityUrl} target="_blank" rel="noreferrer" >Datenschutzerklärung</a> einverstanden.</span>}>
                    </Form.Check>
                </Form.Group>
            </Stack>
        </>
    );
};